export function setupFOUCPreventer() {
    // Select all .override-wpgb-dropdown elements
    document.querySelectorAll('.override-wpgb-dropdown').forEach(dropdown => {
        const facet = dropdown.querySelector('.wpgb-facet');

        if (facet) {
            if (!facet.classList.contains('wpgb-loading')) {
                // Add fouc-prevented class if wpgb-loading is not present
                dropdown.classList.add('fouc-prevented');
            } else {
                // Setup a MutationObserver if wpgb-loading is present
                const observer = new MutationObserver((mutations, obs) => {
                    mutations.forEach(mutation => {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            if (!facet.classList.contains('wpgb-loading')) {
                                dropdown.classList.add('fouc-prevented');
                                obs.disconnect(); // Disconnect the observer after the class change
                            }
                        }
                    });
                });

                // Start observing the .wpgb-facet element
                observer.observe(facet, { attributes: true });
            }
        }
    });
}
